import { useSelector } from "react-redux";
import { Comments } from "../../../../features/comments/components/comments/comments.component";
import * as store from "../../store/campaign-brief.store";
import { TResourceType } from "../../../../types/resources/resources.types";
import { HiddenHeading } from "../../../pages.styles";

export interface CampaignBriefCommentsTabProps {
  pageTitle?: string;
}

export const CampaignBriefCommentsTab = (props: CampaignBriefCommentsTabProps) => {
  const modelId = useSelector(store.getBriefId);
  const modelName = useSelector(store.getResourceType) as TResourceType;

  return (
    <>
      <HiddenHeading>{props.pageTitle}</HiddenHeading>
      <Comments modelId={modelId} modelName={modelName} />
    </>
  );
};
